module.exports = __webpack_public_path__ + "static/media/3.abbf5c18.jpg";